import { TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { parseLocaleCode } from '../../../util/locale-code.js';

export default class LanguageCell extends PureComponent {
  static propTypes = {
    row: PropTypes.object.isRequired
  };

  render() {
    const { code } = this.props.row;
    const { language } = parseLocaleCode(code);
    return <TableCell>{language.name}</TableCell>;
  }
}
